import ForgotPasswordModalProvider from './ForgotPasswordModalProvider';
import FormHandler from '../../forms/FormHandler';
import FacebookLoginForm from './facebook/FacebookLoginForm';
import ForgotPasswordModalElements from './ForgotPasswordModalElements';

interface PageConfig {
  autoShowForgotPasswordModal:boolean;
}

window.tnew.page.initialize = ({ autoShowForgotPasswordModal }: PageConfig) => {
  const $loginForm = document.querySelector<HTMLFormElement>('#tn-login-form')!;

  new FormHandler($loginForm);

  const forgotPasswordModalProvider = new ForgotPasswordModalProvider(ForgotPasswordModalElements);

  forgotPasswordModalProvider.listen();

  if (autoShowForgotPasswordModal) {
    forgotPasswordModalProvider.showModal();
  }

  const $facebookLoginForm = document.querySelector<HTMLFormElement>('#tn-facebook-login-form');

  if ($facebookLoginForm) {
    FacebookLoginForm.init($facebookLoginForm);
  }
};
